import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;
export const PUBLIC_DOMAIN =
  process.env.REACT_APP_PUBLIC_DOMAIN ||
  (typeof window !== "undefined" ? window.location.origin : "");
export const ADMIN_TOKEN_KEY = "ss_admin_token";

export const api = axios.create({ baseURL: API_BASE, timeout: 25000 });

api.interceptors.request.use((config) => {
  const url = config.url || "";
  if (url.startsWith("/admin") && url !== "/admin/login") {
    const token = localStorage.getItem(ADMIN_TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const FALLBACK_ERROR =
  "Maaf, berlaku gangguan sementara. Cuba lagi sebentar.";

export function apiError(error, fallback = FALLBACK_ERROR) {
  const detail = error?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail) && detail.length) {
    const first = detail[0];
    if (first?.msg) {
      const msg = String(first.msg).replace("Value error, ", "");
      if (/email/i.test(String(first.loc || ""))) return "Alamat e-mel tidak sah.";
      return msg;
    }
  }
  if (error?.code === "ECONNABORTED") return "Sambungan terlalu lambat. Cuba lagi.";
  return fallback;
}
